import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, getFormValues } from 'redux-form'
import { Flex, Box } from 'grid-styled'
import Button from '../../elements/Button'
import rem from '../../../styles/tools/rem'
import Hide from '../../../styles/utilities/Hide'
import Icon from '../../elements/Icon/Icon'
import { renderTextInput, renderCvcInput } from '../../../utils/renderInputs'
import { validateCreditCardFlag } from './validators'
import { required, validateCVV, validateAmexCVV } from '../../../utils/validators'
import { utils } from 'alelo-logic'

import { labels } from './data.json'

import { Buttons, Separator, WrapperPayment, BoxCreditCard, ButtonBack } from './style'
import Radio from '../../elements/Radio'
import { errorMessage } from '../../../utils/dictionary'

const renderRadio = ({ input, label, negative, checked, onClick }) => (
  <Radio {...input} label={label} negative={negative} checked={checked} onClick={onClick} />
)

const validate = values => {
  const errors = {}

  if (!values.cardNumber) {
    errors.cardNumber = errorMessage.required
  }

  if (!values.yourName) {
    errors.yourName = errorMessage.required
  }

  if (!values.securityCode) {
    errors.securityCode = errorMessage.required
  }

  if (!values.validad) {
    errors.validad = errorMessage.required
  }

  return errors
}

function CreditCardFields({ formValues }) {
  const creditCardFlag = validateCreditCardFlag((formValues && formValues.cardNumber) || null)
  const validateSecurityCode =
    creditCardFlag === 'amex' ? [required, validateAmexCVV] : [required, validateCVV]

  return (
    <BoxCreditCard>
      <Flex direction="column">
        <Box width={[1, 358]} mb={[17, 20]}>
          <Field
            component={renderTextInput}
            label={labels.cardNumber}
            name="cardNumber"
            validate={utils.creditCardValidate}
            normalize={utils.creditCardMask}
            isRequired
            negative
            placeholder="XXXX XXXX XXXX XXXX"
          />
        </Box>
        <Box width={[1, 358]} mb={[17, 20]}>
          <Field
            component={renderTextInput}
            label={labels.yourName}
            name="yourName"
            isRequired
            negative
            placeholder="Nome do portador do cartão"
          />
        </Box>
        <Flex direction={['column', 'row']} width={[1, 358]} justify="space-between">
          <Box mb={[17, 20]} mr={33} width={[1, 170]}>
            <Field
              component={renderTextInput}
              validate={utils.creditCardValidadValidate}
              normalize={utils.creditCardValidadMask}
              label={labels.validad}
              name="validad"
              isRequired
              negative
              placeholder="mm/aa"
            />
          </Box>
          <Box mb={[17, 37]} width={[1, 170]}>
            <Field
              component={renderCvcInput}
              label={labels.securityCode}
              validate={validateSecurityCode}
              limitDigit={creditCardFlag === 'amex' ? 4 : 3}
              name="securityCode"
              isRequired
              negative
              placeholder="CVV"
            />
          </Box>
        </Flex>
      </Flex>
    </BoxCreditCard>
  )
}

class PaymentForm extends Component {
  state = {
    isCreditCard: false,
    cardFinal: 'XXXX',
    isTrack: false
  }

  onSubmit = (evt, values) => {
    const { isCreditCard } = this.state

    if (values) values.paymentMethod = isCreditCard ? values.paymentMethod : ''

    evt.preventDefault()
    this.props.onSubmit(evt, values)
  }

  render() {
    const {
      creditCardFinaly,
      paymentInfo,
      handleSubmit,
      values,
      accountPlanId,
      loading,
      id,
      location,
      ...props
    } = this.props
    let numeroFinal = paymentInfo.numeroMascarado

    if (numeroFinal !== undefined) {
      numeroFinal = numeroFinal.substring(numeroFinal.length - 4)
    }
    this.isTrack = location.search.includes('path=track')
    this.isRecharge = location.search.includes('path=recharge')

    this.isCreditCard =
      this.props.values && this.props.values.paymentMethod === labels.radiosButtons.debit

    // const textCreditCardFinaly = `Usar cartão final ${numeroFinal || 'XXXX'}`

    const backButton = location.search.includes('path=recharge')
      ? 'recarga/pagamento'
      : 'editar-dados'

    const label = !this.isTrack && !this.isRecharge ? labels.radiosButtons.debit : ''

    return (
      <WrapperPayment>
        <form onSubmit={evt => handleSubmit(this.onSubmit.bind(this.onSubmit(evt, values)))}>
          <Flex direction={['column', 'row']}>
            <Box mb={[39, 28]} width={[1, 458]}>
              <Field
                component={renderRadio}
                label={label}
                name="paymentMethod"
                type="radio"
                value={labels.radiosButtons.debit}
                negative={!this.isTrack && !this.isRecharge}
                disabled={this.isTrack || this.isRecharge}
                checked={this.state.isCreditCard || this.isTrack || this.isRecharge}
                onClick={() => this.setState({ isCreditCard: !this.state.isCreditCard })}
              />
            </Box>
          </Flex>
          <Hide at="large" width={1}>
            {!this.state.isCreditCard && <Separator />}
          </Hide>
          <Flex direction="column">
            {(this.state.isCreditCard && <CreditCardFields formValues={values} />) ||
              (this.isTrack && <CreditCardFields formValues={values} />) ||
              (this.isRecharge && <CreditCardFields formValues={values} />)}{' '}
          </Flex>
          <Buttons>
            <ButtonBack to={`/minha-veloe/${id}/${backButton}`}>
              <Icon
                icon="back-arrow"
                width="10px"
                height="15px"
                viewBox="0 0 10 15"
                hidden={this.isTrack}
              />
              <span hidden={this.isTrack}>Voltar</span>
            </ButtonBack>
            <Box>
              <Button
                text={loading ? 'Carregando' : labels.buttons.save}
                type="submit"
                loading={loading}
                width={rem('220px')}
                disabled={
                  (props.saving || !props.dirty || !props.valid || loading) &&
                  (this.state.isCreditCard || this.isTrack || this.isRecharge)
                  // || ((props.saving || !props.dirty || !props.valid || loading) && this.isTrack)
                }
                buttonType="transparent"
              />
            </Box>
          </Buttons>
        </form>
      </WrapperPayment>
    )
  }
}

const Container = connect((state, reducer) => {
  return {
    values: getFormValues('PaymentForm')(state),
    isCreditCard: state.isCreditCard,
    paymentInfo: state.reducer.recharge.paymentInfo,
    account: reducer.account
  }
}, null)

const Form = reduxForm({
  form: 'PaymentForm',
  validate
})(Container(PaymentForm))

export default Form



// WEBPACK FOOTER //
// ./src/app/modules/EditPaymentForm/index.js